// ABOUTME: DELETE /companies/:id/members/:employerId: staff remove a member from a client company.
// ABOUTME: The company's member list refetches afterwards.
import {
  ErrorMessageEn,
  ErrorMessageEs,
  SuccessMessageEn,
  SuccessMessageEs,
} from '../../../../constants/alerts';
import { errorHandler, successHandler } from '../../../utils';
import { CompanyBuilder, RemoveCompanyMemberInput } from '../companies.types';

export const removeCompanyMember = (builder: CompanyBuilder) =>
  builder.mutation<void, RemoveCompanyMemberInput>({
    query: ({ companyId, employerId }) => ({
      url: `/companies/${companyId}/members/${employerId}`,
      method: 'DELETE',
    }),
    transformResponse: (_response, _, arg) => {
      successHandler(
        arg.lang === 'es'
          ? SuccessMessageEs.MEMBER_REMOVED
          : SuccessMessageEn.MEMBER_REMOVED,
        true
      );
    },
    transformErrorResponse: (error, _, arg) => {
      errorHandler(
        '[removeCompanyMember]',
        arg.lang === 'es'
          ? ErrorMessageEs.RemoveCompanyMember
          : ErrorMessageEn.RemoveCompanyMember,
        error,
        true
      );
      return error.data;
    },
    invalidatesTags: (_result, _error, { companyId }) => [
      { type: 'Company', id: `members-${companyId}` },
    ],
  });
